import { render } from "./CusnewForm.vue?vue&type=template&id=8b4e92c6&scoped=true"
import script from "./CusnewForm.vue?vue&type=script&lang=js"
export * from "./CusnewForm.vue?vue&type=script&lang=js"

import "./CusnewForm.vue?vue&type=style&index=0&id=8b4e92c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4e92c6"]])

export default __exports__